/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type ConfigurationType = "MeetingColors" | "PersonalCalendarSync" | "SettingUpTeam" | "SettingUpWorkingHours" | "ShadowCalendar" | "SlackStatusSync" | "TravelTime" | "%future added value";
export type SuggestionType = "AutopilotAttendee" | "ChromeExtensionTip" | "ConflictingMeeting" | "ExpensiveMeeting" | "ExpensiveOrganizer" | "LowFocusTime" | "MeetingNotOnAutopilot" | "MissingAttendance" | "MissingUserConfiguration" | "RecurringOneOnOneOrganizer" | "RunningOutOfFocusTime" | "Shell" | "TeammateOutOfOffice" | "WeekInReview" | "WeeklyAutopilotSummary" | "%future added value";
export type TipType = "CheckOutProfile" | "CheckOutRescheduler" | "CheckOutTeamDashboard" | "FeedWelcome" | "%future added value";
export type SuggestionCardHeader_feedSuggestion = {
    readonly occurredMillis: unknown | null;
    readonly suggestionId: string | null;
    readonly suggestionType: SuggestionType | null;
    readonly text: {
        readonly title: string | null;
        readonly subHeading: string | null;
    } | null;
    readonly suggestionPayload: ({
        readonly __typename: "SuggestionResultChromeExtensionTipPayload";
        readonly tipType: TipType | null;
    } | {
        readonly __typename: "SuggestionResultMissingUserConfigurationPayload";
        readonly configurationType: ConfigurationType | null;
    } | {
        /*This will never be '%other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    }) | null;
    readonly " $refType": "SuggestionCardHeader_feedSuggestion";
};
export type SuggestionCardHeader_feedSuggestion$data = SuggestionCardHeader_feedSuggestion;
export type SuggestionCardHeader_feedSuggestion$key = {
    readonly " $data"?: SuggestionCardHeader_feedSuggestion$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"SuggestionCardHeader_feedSuggestion">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SuggestionCardHeader_feedSuggestion",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "occurredMillis",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "suggestionId",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "suggestionType",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "FeedSuggestionText",
            "kind": "LinkedField",
            "name": "text",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "title",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "subHeading",
                    "storageKey": null
                }
            ],
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "suggestionPayload",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "tipType",
                            "storageKey": null
                        }
                    ],
                    "type": "SuggestionResultChromeExtensionTipPayload",
                    "abstractKey": null
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "configurationType",
                            "storageKey": null
                        }
                    ],
                    "type": "SuggestionResultMissingUserConfigurationPayload",
                    "abstractKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "FeedSuggestion",
    "abstractKey": null
} as any;
(node as any).hash = '1da14beb0f69a92438c1c7d5cd54d4cf';
export default node;
